import {ReactMarkdownProps} from 'react-markdown/lib/ast-to-react';
import cx from 'classnames';

import {Text} from '#component/base';
import {TextProps} from '#component/base/Text';
import {sprinkles} from '#style/sprinkles';

import {listNumber} from '../Markdown.css';

export const ListItem = ({
  className,
  children,
  ordered,
  index = 0,
  ...otherProps
}: TextProps<'li'> & Omit<ReactMarkdownProps, 'color'> & {ordered?: boolean}) => {
  return (
    <Text
      as="li"
      className={cx(sprinkles({flex: 'flex', items: 'center', gap: 16, pY: 16}), className)}
      {...otherProps}>
      <Text variant="caption" className={listNumber({ordered})}>
        {/* Render a number or bullet depending if it's an OL or UL */}
        {ordered ? index + 1 : '•'}
      </Text>
      <span>{children}</span>
    </Text>
  );
};
